import React from 'react';
import { Anchor } from 'antd';
import { AnchorProps as AnchorCopyProps } from 'antd/lib/anchor';

export type AnchorProps = AnchorCopyProps;

const ProAnchor: React.FC<AnchorProps> = (props) => {
    return (
      <Anchor {...props} />
    );
  };

export default ProAnchor;
